import { Toaster as Sonner, ToasterProps } from "sonner";
import { Z_INDEX } from "../lib/z-index";

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      theme="light"
      className="toaster group"
      {...props}
      toastOptions={{
        ...props.toastOptions,
        style: {
          zIndex: Z_INDEX.toast,
          ...props.toastOptions?.style,
        },
      }}
    />
  );
};

export { Toaster };
